jQuery(document).ready(function ($) {

  var module_name = 'toplist';

  $('.' + module_name.replace(/_/g, '-') + '-module').each(function (index) {

    // getting the necessary fields that i need to implement the logic behind the load more button
    var default_number_casinos = parseInt(modules_object[module_name][index].default_number_casinos);
    var number_of_rows = parseInt(modules_object[module_name][index].number_of_rows);
    var allow_load_more = modules_object[module_name][index].allow_load_more;

    // getting the elements for each toplist
    var toplist_elements = this.getElementsByClassName('toplist-item');
    var load_more_button = this.getElementsByClassName('load-more-btn');

    // hide all the data first so than we can add how many rows we want.
    $(toplist_elements).hide();
    addTableRow(toplist_elements);

    //remove the button if there are no elements, or if there are no more elements.
    if(toplist_elements.length <= default_number_casinos || toplist_elements.length == 0){
        $(load_more_button).hide();
    }

    // button functionality 
    $(load_more_button).click(function () {
      default_number_casinos+=number_of_rows;
      addTableRow(toplist_elements);
      if(toplist_elements.length <= default_number_casinos){
        $(load_more_button).hide();
      }
    });


    var module = $(this);
    $(module).each(function(counter_of_modules){
      module.on('click', '.filter-link', function () {
      // reset the rows limit to default when we click on another tab. 
      module.find('.filter-link').removeClass('active');
      $(this).addClass('active');
      default_number_casinos = parseInt(modules_object[module_name][index].default_number_casinos);
      $.ajax({
               datatype: 'html',
               url: script_object.ajax_url,
               type: 'POST',
               data: {
                 action: module_name,
                 function: 'toplist_by_name',
                 name: $(this).attr('id'),
                 data: modules_object[module_name][index]['data']
               },
               success: function (data) {
                 module.find('.tab-content').html(data);

                  // getting the elements for each toplist
                  var toplist_elements_tabs = module[counter_of_modules].getElementsByClassName('toplist-item');
                  var load_more_button_tabs = module[counter_of_modules].getElementsByClassName('load-more-btn');

                  // hide all the data first so than we can add how many rows we want.
                  $(toplist_elements_tabs).hide();
                  addTableRow(toplist_elements_tabs);

                  //remove the button if there are no elements, or if there are no more elements. 
                  if(toplist_elements_tabs.length <= default_number_casinos || toplist_elements_tabs.length == 0){
                      $(load_more_button_tabs).hide();
                  }

                  // button functionality 
                  $(load_more_button_tabs).click(function () {
                    default_number_casinos+=number_of_rows;
                    addTableRow(toplist_elements_tabs);
                    if(toplist_elements_tabs.length <= default_number_casinos){
                      $(load_more_button_tabs).hide();
                    }
                  });
               }
             });
      });
    });
    
    // the addTableRow function adds the exact number of rows that we want.  
    function addTableRow($class_name){
        $( $class_name ).each(function( counter_of_rows ) {
          if(allow_load_more == false){
            $(this).show();
          }
          else{
            if(counter_of_rows+1 <= default_number_casinos){
              $(this).show();
            }
          }
        });
    }

  });
});